import React from 'react';
import { Checkbox, Link } from '@one-thd/sui-atomic-components';
import SubscriptionPopOverMessage from './SubscriptionPopoverMessage';
import { SUBSCRIPTION_LABEL } from '../../../constants/order-details';
var SubscriptionCheckbox = function (props) {
    var subscriptionChecked = props.subscriptionChecked, handleSubscriptionChange = props.handleSubscriptionChange;
    return (React.createElement("div", { className: "sui-flex sui-my-4" },
        React.createElement("div", null,
            React.createElement(Checkbox, { checked: subscriptionChecked, onChange: handleSubscriptionChange, inputAttributes: { 'aria-label': 'subscription-checkbox' } })),
        React.createElement("div", { className: "sui-mt-1" },
            React.createElement(Link, { onClick: handleSubscriptionChange, underline: "none", variant: "body-base", weight: "bold" }, SUBSCRIPTION_LABEL),
            React.createElement(SubscriptionPopOverMessage, null))));
};
export default SubscriptionCheckbox;
